import {useRef, useState} from "react";
import {Camera, Loader2, Plus, X} from "lucide-react";
import {FormModal} from "@/components/UI";
import {apiPut, apiUpload} from "@/lib/api";

export default function EditProfileModal({user, setUser, close, notify}) {
  const [f, setF] = useState({name: user.name || "", headline: user.headline || "", city: user.city || "", bio: user.bio || "", picture: user.picture || ""});
  const [links, setLinks] = useState(user.links?.length ? user.links : [""]);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);
  const ch = e => setF({...f, [e.target.name]: e.target.value});

  const upload = async (file) => {
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { notify("Photo must be under 5MB"); return; }
    setUploading(true);
    try { const r = await apiUpload(file); setF(x => ({...x, picture: r.url})); }
    catch { notify("Upload failed, please try again"); }
    finally { setUploading(false); }
  };

  const save = async (e) => {
    e.preventDefault();
    try {
      const u = await apiPut("/users/me/profile", {...f, links: links.map(l => l.trim()).filter(Boolean)});
      setUser(u); notify("Profile saved"); close();
    } catch (err) { notify(err?.response?.data?.detail || "Please check your details"); }
  };

  return (
    <FormModal title="Edit profile" eyebrow="YOUR PROFILE" close={close} testId="edit-profile">
      <form onSubmit={save}>
        <div className="edit-photo">
          <div className="profile-avatar small">{f.picture ? <img src={f.picture} alt=""/> : (f.name[0] || "?")}</div>
          <input ref={fileRef} type="file" accept="image/*" style={{display: "none"}} data-testid="edit-photo-input" onChange={e => upload(e.target.files[0])}/>
          <button type="button" data-testid="edit-photo" className="outline-button sm" onClick={() => fileRef.current?.click()} disabled={uploading}>
            {uploading ? <Loader2 size={14} className="spin"/> : <Camera size={14}/>} Change photo
          </button>
        </div>
        <label>Name<input data-testid="edit-name" required minLength={2} name="name" value={f.name} onChange={ch}/></label>
        <label>Headline<input data-testid="edit-headline" name="headline" value={f.headline} onChange={ch} placeholder="Pharmacist · Garba lover"/></label>
        <label>City<input data-testid="edit-city" name="city" value={f.city} onChange={ch} placeholder="Edison, New Jersey"/></label>
        <label>About me<textarea data-testid="edit-bio" name="bio" value={f.bio} onChange={ch} maxLength={1500} placeholder="A little about you, your roots and what you're looking for"/></label>
        <label>Links
          {links.map((l, i) => (
            <div className="link-row" key={i}>
              <input data-testid={`edit-link-${i}`} type="url" value={l} onChange={e => setLinks(links.map((x, j) => j === i ? e.target.value : x))} placeholder="https://linkedin.com/in/..."/>
              {links.length > 1 && <button type="button" className="icon-button" onClick={() => setLinks(links.filter((_, j) => j !== i))}><X size={14}/></button>}
            </div>
          ))}
          {links.length < 6 && <button type="button" data-testid="edit-add-link" className="switch-auth" onClick={() => setLinks([...links, ""])}><Plus size={12}/> Add link</button>}
        </label>
        <button data-testid="edit-save" className="coral-button full" type="submit">Save profile</button>
      </form>
    </FormModal>
  );
}
